import type { ReactNode } from 'react';
import { PhotoViewer, type ViewerPhoto } from '../../ui/PhotoViewer.js';
import { PortalPhoto } from './PortalPhoto.js';

/**
 * Visionneuse intégrée du portail : l'image passe par la même route d'API que les vignettes
 * (`portal.mediaFile`, jeton en en-tête), sans nouvel onglet et sans toucher au fragment de l'adresse.
 */
export function PortalPhotoViewer({
  photos,
  open,
  onIndexChange,
  onClose,
  meta,
}: {
  photos: ViewerPhoto[];
  open: number | null;
  onIndexChange: (i: number) => void;
  onClose: () => void;
  meta?: (photo: ViewerPhoto) => ReactNode;
}) {
  if (open === null) return null;
  return (
    <PhotoViewer
      photos={photos}
      index={open}
      onIndexChange={onIndexChange}
      onClose={onClose}
      {...(meta ? { meta } : {})}
      render={(p) => <PortalPhoto id={p.id} variant="display" alt={p.alt} className="max-h-[calc(100dvh-11rem)] w-full object-contain" />}
    />
  );
}
